import * as XLSX from 'xlsx';
import { AlertError } from "../../usableclasses.js";

export const handleTellerSummaryExportToExcel = (dataSource, setIsLoading) => {
    if (!dataSource || dataSource.length === 0) {
        AlertError("No data to export.");
        return;
    }
    if (setIsLoading) setIsLoading(true);

    // Prepare data for Excel
    const dataForExcel = dataSource.map(item => ({
        "Order No": item.invoiceNo,
        "Current Status": item.invoiceStatus,
        "Order Total": item.orderCost,
        "Paid Type": item.transactionType,
        "Paid Amount": item.transactionAmount,
        "Payment Details": item.transactionDetail,
        "Transaction Date/Time": item.transactionTime,
        "Transaction Desc": item.transactionLogDesc
    }));

    // Add total row
    const totalOrderCost = dataSource.reduce((sum, item) => sum + (item.transactionAmount || 0), 0);
    const paidCount = dataSource.filter(item => item.invoiceNo).length;
    dataForExcel.push({}); // Empty row for spacing
    dataForExcel.push({
        "Order No": "Summary",
        "Current Status": `Transactions: ${paidCount}`,
        "Order Total": totalOrderCost.toFixed(2)
    });

    const worksheet = XLSX.utils.json_to_sheet(dataForExcel);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Teller Summary");
    const excelFileName = `Teller_Summary_${new Date().toISOString().slice(0, 10)}.xlsx`;
    XLSX.writeFile(workbook, excelFileName);
    if (setIsLoading) setIsLoading(false);
};
